import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import './OurPartnersPage.scss';

class OurPartnersPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;

        return (
            <main role="main" className="conteneur conteneur-mobile" id="p-ourpartners">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.OUR_PARTNERS_PATH}`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: i18n.BREADCRUMB,
                            route: PATH.OUR_PARTNERS_PATH
                        }
                    ]}
                />
                <h1>{i18n.TITLE}</h1>

                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_1)}</p>
                <p>{i18n.TEXT1_2}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_1)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_2)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_3)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_4)}</p>
                <p>{i18n.TEXT2_5}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_6)}</p>
                <p>{i18n.TEXT2_7}</p>
                <p>{i18n.TEXT2_8}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_1)}</p>
                <p>{i18n.TEXT3_2}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_3)}</p>
                <p>{i18n.TEXT3_4}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_5)}</p>
                <p>{i18n.TEXT3_6}</p>
                <ul>
                    <li>{i18n.TEXT3_7}</li>
                </ul>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_8)}</p>
                <p>{i18n.TEXT3_9}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_10)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_11)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_12)}</p>
                <ul>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT3_13)}</li>
                    <li>{i18n.TEXT3_14}</li>
                </ul>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <p>{i18n.TEXT4_2}</p>
                <ol>
                    <li>{i18n.TEXT4_3}</li>
                    <li>{i18n.TEXT4_4}</li>
                </ol>
                <p>{i18n.TEXT4_5}</p>

                <hr />
                <p>{convertHtmlToReactDomWithParams(i18n.MENTION_1)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.MENTION_2)}</p>
            </main>
        );
    }
}

OurPartnersPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.OUR_PARTNERS
    };
}

export default withTemplate(connect(mapStateToProps)(OurPartnersPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/ourpartners/OurPartnersPage.js